var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"settings"},[_c('div',{staticClass:"setttings__box"},[_c('TitleCommon',{attrs:{"value":"settings"}}),_c('Nav',{attrs:{"step":_vm.step},on:{"on-change-step":_vm.onChangeStep}}),(_vm.step === 1)?_c('ResetPin'):(_vm.step === 2)?_c('Print'):_c('Version')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }